import { createEffect, createEvent, createStore } from 'effector';
import { PortalBlock, ScreenItem, ScreenType } from '@nx-frontend/shared/types';
import { setCookie } from '@nx-frontend/shared/utils';
import { resetScreenStore } from './reset-screen-store';

export const controlbarCollapsedCookiesKey = 'controlbar-collapsed';
export const navigateEvent = createEvent<{
  screen: ScreenItem;
  backAnimation?: boolean;
  backNavigation?: boolean;
  clearHistory?: boolean;
}>();
export const updateCurrentScreenEvent = createEvent<{ screen: ScreenItem }>();
export const navigateBackEvent = createEvent<{ backAnimation?: boolean }>();
export const navigateAnimationIsActiveEvent = createEvent<boolean>();
export const scrollToBlockEvent = createEvent<PortalBlock | null>();

export const setIsControlbarCollapsedAndSaveToCookiesFx = createEffect((value: boolean) => {
  setCookie(controlbarCollapsedCookiesKey, value.toString());
  return value;
});

export interface CustomizerControlbarState {
  history: ScreenItem[];
  backAnimation: boolean;
  animationIsActive: boolean;
  previousScreen?: ScreenItem;
  scrollToBlock?: PortalBlock | null;
  isCollapsed: boolean;
}

export const initialCustomizerControlbarState: CustomizerControlbarState = {
  history: [{ type: ScreenType.MAIN }],
  backAnimation: false,
  animationIsActive: false,
  scrollToBlock: null,
  isCollapsed: false,
};

export const $controllbarCollapsed = createStore(false).on(
  setIsControlbarCollapsedAndSaveToCookiesFx.doneData,
  (state, value) => {
    return value;
  }
);

export const $controlBarState = createStore(initialCustomizerControlbarState)
  .on(navigateEvent, (state, { screen, backAnimation = false, backNavigation = false, clearHistory = false }) => {
    return {
      ...state,
      backAnimation,
      previousScreen: state.history[0] ?? undefined,
      history: clearHistory
        ? [screen, { type: ScreenType.MAIN }]
        : screen.type === ScreenType.MAIN
        ? [screen]
        : !backNavigation
        ? [screen, ...state.history]
        : [screen, ...state.history.slice(2)],
    };
  })
  .on(navigateBackEvent, (state, { backAnimation = true }) => {
    return {
      ...state,
      backAnimation,
      previousScreen: state.history[0] ?? undefined,
      history: state.history.slice(1),
    };
  })
  .on(navigateAnimationIsActiveEvent, (state, animationIsActive) => {
    return { ...state, animationIsActive };
  })
  .on(scrollToBlockEvent, (state, block) => {
    return { ...state, scrollToBlock: block };
  })
  .on(updateCurrentScreenEvent, (state, { screen }) => {
    if (screen.type !== state.history[0].type) {
      console.warn('Can not update screen type');
      return state;
    }
    return { ...state, history: [screen, ...state.history.splice(1)] };
  });

export const $customizerControlbarCurrentScreen = $controlBarState.map((state) => state.history[0]);
export const $customizerControlbarBackScreen = $controlBarState.map(
  (state) => state.history[state.history.length > 1 ? 1 : 0]
);
export const $customizerControlbarPreviousScreen = $controlBarState.map((state) => state.previousScreen);
export const $customizerControlbarBackAnimation = $controlBarState.map((state) => state.backAnimation);
export const $scrolledBlock = $controlBarState.map((state) => state.scrollToBlock);

resetScreenStore();
